import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

function BAButton(props) {
  const { label, onClick, loading, disabled, variant, color, startIcon, endIcon, fullWidth } = props;
  return (
    <>
      <Button
        sx={{
          borderRadius: 2,
          textTransform: "inherit",
        }}
        disabled={loading || disabled}
        onClick={onClick}
        variant={variant ?? "contained"}
        color={color}
        startIcon={startIcon}
        endIcon={endIcon}
        fullWidth={fullWidth}
      >
        {loading ? <CircularProgress size={25} /> : label}
      </Button>
    </>
  );
}
export default BAButton;
